// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"ae33a3d7","419":"a235323a","490":"48e5f985","677":"24b2e678","735":"d61e344a"}[chunkId] + ".chunk.css";
};